import React from 'react';
import Styled from 'styled-components';
import PropTypes from 'prop-types';

const BannerDiv = Styled.div`
background: #5A5A5A;
padding:10px;
max-height:100%
`;

const PageBanner = (props) => (
  <BannerDiv>
    <span style={{ color: '#FFFFFF', display: 'flex', justifyContent: 'center', flexWrap: 'wrap', alignItems: 'center' }}>
      {props?.acpBannerContent}
    </span>
  </BannerDiv>
);

PageBanner.propTypes = {
  acpBannerContent: PropTypes.string,
};

export default PageBanner;